import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import './ProductCard.css';

const ProductCard = ({ producto }) => {
  const numeroWhatsapp = "5492995343092"; 
  // Mensaje dinámico que incluye el nombre del queso que están mirando
  const mensajeDefault = `¡Hola! Vengo de la web y me interesa el ${producto.nombre}.`;
  const linkWhatsapp = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensajeDefault)}`;

  return (
    <div className="product-card">
      <div className="card-image-container">
        <Link to={`/productos/${producto.id}`}>
          <img src={producto.imagen} alt={producto.nombre} className="card-image" />
        </Link>
      </div>
      
      <div className="card-content">
        <Link to={`/productos/${producto.id}`} className="card-title-link">
          <h3>{producto.nombre}</h3>
        </Link>
        <p className="card-description">{producto.descripcion}</p>
        
        <div className="card-details">
          <span><strong>Peso:</strong> {producto.peso}</span>
        </div>

        <div className="card-actions">
          <Link to={`/productos/${producto.id}`} className="btn-ver-mas">
            Ver detalle
          </Link>
          <a href={linkWhatsapp} target="_blank" rel="noopener noreferrer" className="btn-comprar-wa">
            <FaWhatsapp /> Comprar
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;